/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Box, Dialog, DialogContent, DialogTitle, IconButton, Modal } from '@mui/material'
import { wc } from '@utdx/rotor-react-wc-shim'
import CloseIcon from '@mui/icons-material/Close';
import React from 'react'
import styles from '../../styles/FormLayout.module.css'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';


interface IProps {
  open: boolean
  handleClose: () => void
  type?: MessageType
  message?: string 
  messageHTML?: JSX.Element 
  title?: string
  style?: any
}



export enum MessageType {
  info,
  warning,
  error,
  success,
  dialog
}

export default function SuccessErrorModal({ open,
  handleClose,
  title,
  style,
  type = MessageType.error,
  message = 'Something went wrong...',
  messageHTML = <></>
}: IProps) {


  const getModalBasedOnType = () => {

    if (open) {
      let modal = <></>;
     
      if (type === MessageType.dialog) {
        if (messageHTML === <></>){
          modal = (
            <div>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                  {title}{" "}
                  {handleClose ? (
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : null}
                </DialogTitle>
                <DialogContent>
                  <div dangerouslySetInnerHTML={{ __html: message }}></div>
                </DialogContent>
              </Dialog>
            </div>
          );
        } else{
          modal = (
            <div>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                  {title}{" "}
                  {handleClose ? (
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : null}
                </DialogTitle>
                <DialogContent>
                  <div> {messageHTML} </div>
                </DialogContent>
              </Dialog>
            </div>
          );
        }
      } else if (type === MessageType.success) {
        let style:React.CSSProperties={};
        let icon:string = 'true';
        switch(type){
          case MessageType.success:
            icon='false';
            style= {background: '#34CB81',color:'#000000',fontFamily: 'Inter',fontStyle: 'normal',fontWeight: '400', fontSize: '14px',lineHeight: '22px'}
            break;
        }
         modal = <div>
           <rotor-alert
             style={style}
             ref={wc({
               events: {
                 rotorclose: handleClose,
               },
               icon: icon,
               size: 'large',
             })}
           >
             {message}
           </rotor-alert>
         </div>
       } else if(type === MessageType.error) { 
        let style: React.CSSProperties = {};
        let icon: string = "true";
        modal = (
          <div>
            <div className={styles.successErrorModelerror}>
              <div className={styles.successEroorModelsign}><rotor-icon class="rotor-alert--icon hydrated" name="alert" size="standard"></rotor-icon></div>
              <div className={styles.successEroorModeltext} dangerouslySetInnerHTML={{ __html: message }} ></div>
              <div className={styles.successEroorModelClose}><a style={{color:"white"}} onClick={handleClose}>
                <rotor-icon class="rotor-alert--icon hydrated" name="close" size="standard"></rotor-icon>
                </a>
              </div>
            </div>
          </div>
        );
      } else{ 
        let style: React.CSSProperties = {};
        let icon: string = "true";
        modal = (
          <div>
            <div className={styles.successErrorModelinfo}>
              <div className={styles.successEroorModelsign}><rotor-icon class="rotor-alert--icon hydrated" name="alert" size="standard"></rotor-icon></div>
              <div className={styles.successEroorModeltext}><div dangerouslySetInnerHTML={{ __html: message }}></div></div>
              <div className={styles.successEroorModelClose}><a style={{color:"white"}} onClick={handleClose}>
                <rotor-icon class="rotor-alert--icon hydrated" name="close" size="standard"></rotor-icon>
                </a></div>
            </div>
          </div>
        );
      }



      return modal;
    } else {
      return undefined
    }
  }




  return (
    <>
    { getModalBasedOnType() }
    </>
  );
}
